import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import CasesApi from "../../api/cases/index.js";
import { usePermissions } from "../../hooks/usePermissions";
import DropdownMenu from "../../Monolith-UI/DropdownMenu/DropdownMenu.js";
import CaseProgressApi from "@/api/case-progress/index";

const ProgressSelector = ({ rowData, onChange = () => {} }) => {
  const { hasPermission } = usePermissions();
  const [current, setCurrent] = useState(rowData.progress);
  const queryClient = useQueryClient();
  const cachedData = queryClient.getQueryData(["cases:progress"]);
  const containerRef = useRef(null);

  const { data: progressItems } = useQuery({
    queryKey: ["cases:progress"],
    queryFn: () => CaseProgressApi.getCaseProgress(),
    enabled: !cachedData,
    placeholderData: (data) => data || [],
  });

  const currentProgress =
    progressItems?.find((p) => p.progress_name === current) || {};

  const handleItemSelect = async (item) => {
    containerRef.current.classList.remove("custom-action-button");
    setCurrent(item.progress_name);
    await CasesApi.updateCase(rowData.case_id, {
      progress: item.progress_name,
    });

    onChange({ progress: item.progress_name, progress_id: item.progress_id });
  };

  const menuItems = [
    {
      radioGroup: true,
      value: currentProgress?.progress_id,
      onSelectionChanged: (data) => {
        handleItemSelect(
          progressItems.find((p) => p.progress_id === data.value)
        );
      },
      items: progressItems.map((p) => ({
        label: p.progress_name,
        value: p.progress_id,
      })),
    },
  ];

  return (
    <div
      ref={containerRef}
      className={`${currentProgress ? "" : "custom-action-button"}`}
    >
      <DropdownMenu
        menuItems={menuItems}
        disabled={!hasPermission()}
        title={"Select Progress"}
        variant={"contained"}
        textColor={current ? "primary" : "secondary"}
        buttonProps={{
          style: {
            fontSize: 12,
          },
        }}
      >
        {current ? <div>{current}</div> : <div>Select...</div>}
      </DropdownMenu>
    </div>
  );
};

export default ProgressSelector;
